<div class="full-page login-banner w-100">
  <div class="container">
    <div class="d-flex justify-content-center">
      <img alt="" [height]="100" src="assets/images/logos/NYJLogo.png" class="logo mb-5" />
    </div>
    <div class="d-flex justify-content-center">
      <div class="content-container">
        <form (submit)="submit()" [formGroup]="formChangePassword">
          <h5 class="change-password-title">{{ 'change.pw.title' | translate }}</h5>
          <p
            class="user-change-password-instruction font-size-14 mb-4"
            [innerHtml]="'user.change.password.instruction' | translate"
          ></p>
          <div class="form-input mb-3">
            <div class="form-floating position-relative">
              <input class="form-control" [type]="visiblePassword ? 'text' : 'password'" formControlName="password" />
              <label>{{ 'change.pw.label' | translate }}</label>
              <span
                class="visible-icon material-icons cursor-pointer text-info"
                (click)="toggleVisiblePassword()"
                *ngIf="visiblePassword"
              >
                visibility
              </span>
              <span
                class="visible-icon material-icons cursor-pointer text-info"
                (click)="toggleVisiblePassword()"
                *ngIf="!visiblePassword"
              >
                visibility_off
              </span>
            </div>
            <div class="text-danger font-size-12 mt-2" *ngIf="checkForm['password']">
              {{ 'change.pw.warn.valid' | translate }}
            </div>
          </div>
          <div class="form-input mb-3">
            <div class="form-floating position-relative">
              <input class="form-control" [type]="visibleConfirm ? 'text' : 'password'" formControlName="confirmPassword" />
              <label>{{ 'change.pw.label.confirm' | translate }}</label>
              <span
                class="visible-icon material-icons cursor-pointer text-info"
                (click)="toggleVisibleConfirm()"
                *ngIf="visibleConfirm"
              >
                visibility
              </span>
              <span
                class="visible-icon material-icons cursor-pointer text-info"
                (click)="toggleVisibleConfirm()"
                *ngIf="!visibleConfirm"
              >
                visibility_off
              </span>
            </div>
            <div class="text-danger font-size-12 mt-2" *ngIf="checkForm['confirmPassword']">
              {{ 'change.pw.warn.confirm' | translate }}
            </div>
          </div>
          <div class="btn-submit action-buttons">
            <button
              type="submit"
              [disabled]="formChangePassword.invalid || !isPasswordSameConfirm"
              class="w-100 btn btn-primary fw-bold"
            >
              {{ 'change.pw.btn' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #alert let-modal>
  <div class="modal-body">
    <div class="text-center mt-4">{{ contentModal }}</div>
  </div>
  <div class="modal-footer border-top-0">
    <button type="button" class="btn btn-success" (click)="modal.close()" [routerLink]="['/login']">
      {{ 'change.pw.confirm.button' | translate }}
    </button>
  </div>
</ng-template>
